import { createSlice } from "@reduxjs/toolkit";
import { ReportDownload, ReportDownloadByCategoryVsBrand, ReportDownloadByCategoryHorizontal, ReportDownloadByDepartmentVsCategory} from "services/report/report.service";
import { toast } from 'react-toastify';

export const reportListSlice = createSlice({
  name: "reportList",
  initialState: {
    reportList: [],
    reportListLoading: false,
    reportListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(ReportDownload.pending, (state) => {
      state.reportListLoading = true
    });

    builder.addCase(ReportDownload.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.reportList = action.payload
      state.reportListLoading = false
      state.reportListError = null
    });

    builder.addCase(ReportDownload.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.reportListLoading = false
      state.reportListError = action.error?.message
    });
  },
});


export const reportListByCategoryHorizontalSlice = createSlice({
  name: "reportListByCategoryHorizontal",
  initialState: {
    reportListByCategoryHorizontal: [],
    reportListByCategoryHorizontalLoading: false,
    reportListByCategoryHorizontalError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(ReportDownloadByCategoryHorizontal.pending, (state) => {
      state.reportListByCategoryHorizontalLoading = true
    });

    builder.addCase(ReportDownloadByCategoryHorizontal.fulfilled, (state, action) => {
      toast.dismiss();

      state.reportListByCategoryHorizontal = action.payload
      state.reportListByCategoryHorizontalLoading = false
      state.reportListByCategoryHorizontalError = null
    });

    builder.addCase(ReportDownloadByCategoryHorizontal.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.reportListByCategoryHorizontalLoading = false
      state.reportListByCategoryHorizontalError = action.error?.message
    });
  },
});

export const reportListByCategoryVsBrandSlice = createSlice({
  name: "reportListByCategoryVsBrand",
  initialState: {
    reportListByCategoryVsBrand: [],
    reportListByCategoryVsBrandLoading: false,
    reportListByCategoryVsBrandError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(ReportDownloadByCategoryVsBrand.pending, (state) => {
      state.reportListByCategoryVsBrandLoading = true
    });

    builder.addCase(ReportDownloadByCategoryVsBrand.fulfilled, (state, action) => {
      toast.dismiss();

      state.reportListByCategoryVsBrand = action.payload
      state.reportListByCategoryVsBrandLoading = false
      state.reportListByCategoryVsBrandError = null
    });

    builder.addCase(ReportDownloadByCategoryVsBrand.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.reportListByCategoryVsBrandLoading = false
      state.reportListByCategoryVsBrandError = action.error?.message
    });
  },
});

export const reportListByDepartmentVsCategorySlice = createSlice({
  name: "reportListByDepartmentVsCategory",
  initialState: {
    reportListByDepartmentVsCategory: [],
    reportListByDepartmentVsCategoryLoading: false,
    reportListByDepartmentVsCategoryError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(ReportDownloadByDepartmentVsCategory.pending, (state) => {
      state.reportListByDepartmentVsCategoryLoading = true
    });

    builder.addCase(ReportDownloadByDepartmentVsCategory.fulfilled, (state, action) => {
      toast.dismiss();

      state.reportListByDepartmentVsCategory = action.payload
      state.reportListByDepartmentVsCategoryLoading = false
      state.reportListByDepartmentVsCategoryError = null
    });

    builder.addCase(ReportDownloadByDepartmentVsCategory.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.reportListByDepartmentVsCategoryLoading = false
      state.reportListByDepartmentVsCategoryError = action.error?.message
    });
  },
});